/** Generic silhouette used when no profile photo is uploaded. */
import DEFAULT_USER_AVATAR from "../Components/Images/default-user-avatar.svg";

export default DEFAULT_USER_AVATAR;
export { DEFAULT_USER_AVATAR };
